module.exports = __webpack_public_path__ + "img/banner_darker.3f60f1fc.png";